/**
 * Single source of truth for the list of AI narrators the app exposes to
 * end-users and to search-engine copy. SEO pages, FAQs, and comparison
 * tables import from here so we can rename or add a model in ONE place
 * rather than chasing six landing pages every time the roster changes.
 *
 * `LAST_UPDATED` is surfaced via structured data (`dateModified`) on
 * SEO pages so LLM crawlers can tell how fresh the content is.
 */

export const NARRATORS = [
  { id: "claude-sonnet",  label: "Claude Sonnet 4.5", default: true,  vibe: "warm, long-form continuity" },
  { id: "claude-haiku",   label: "Claude Haiku 4.5",  default: false, vibe: "fast, efficient" },
  { id: "gpt-5",          label: "GPT-5",             default: false, vibe: "cinematic pacing" },
  { id: "gemini-2-5-pro", label: "Gemini 2.5 Pro",    default: false, vibe: "fast, versatile" },
];

/** Pretty-printed comma list. Example: "Claude Sonnet 4.5, Claude Haiku 4.5, GPT-5, Gemini 2.5 Pro". */
export const NARRATOR_LIST = NARRATORS.map((n) => n.label).join(", ");

/** Short marketing sentence — used in feature cards and FAQ answers. */
export const NARRATOR_SWITCHER_LINE = `Switch between ${NARRATOR_LIST}. The Memory Codex is designed to carry state across the swap.`;

/** ISO date. Bump when you change the roster or major SEO copy so the
 *  BreadcrumbList / FAQPage schemas expose a fresh `dateModified`. */
export const CONTENT_LAST_UPDATED = "2026-02-14";
export const CONTENT_FIRST_PUBLISHED = "2025-09-01";
